'use client';

import { ReactNode } from 'react';
import { useSelector } from 'react-redux';
import { selectFeatureToggles } from '@next-app/lib/features/InitSelectors';
import classes from './product-card.module.scss';

const ProductCardWrapper = ({ children }: { children: ReactNode }) => {
  const featureToogle = useSelector(selectFeatureToggles);
  const enhancedTypeAheadEnabled =
    featureToogle?.enhancedTypeAheadEnabled ?? false;
  return (
    <div
      className={`${enhancedTypeAheadEnabled ? classes['product-card-wrapper'] : ''}`}
    >
      {children}
    </div>
  );
};

export default ProductCardWrapper;
